import { useToast } from "@chakra-ui/react" ;
import { useEffect, useState } from "react" ;

import { $ok } from "foundation-ts/commons" ;
import { Nullable } from "foundation-ts/types";
import { ConsumptionsStructure } from "@bcasmart/doxecure-commons/doxecureTypes";

import { ConsumptionsBox } from "@components/ConsumptionsBox/ConsumptionsBox";
import { useAuthContext } from "@hooks/useAuthContext";
import { exportConsumptions, getConsumptions, getCurrentConsumption } from "@services/stats.service";
import { defaultErrorToast } from "@utils/toast" ;

export const ConsumptionsTab = () => {
    const [nbQualified, setNbQualified] = useState<number>(0) ;
    const [nbAdvanced, setNbAdvanced] = useState<number>(0) ;
    const [consumptions, setConsumptions] = useState<Nullable<ConsumptionsStructure>>(null) ;
    const { connectedProfileId } = useAuthContext();
    const toast = useToast() ;

    useEffect(() => {
        const currentConsumption = async () => {
            const currentConsumption = await getCurrentConsumption(connectedProfileId) ;
            setNbQualified($ok(consumptions) ? currentConsumption!.qualified : -1) ;
            setNbAdvanced($ok(consumptions) ? currentConsumption!.advanced : -1) ;
        }

        const consumptions = async () => {
            const data = await getConsumptions(connectedProfileId) ;
            setConsumptions($ok(data) ? data! : null) ;
        }

        currentConsumption() ;
        consumptions() ;
    }, []);

    const onExportConsumptions = async () => {
        try {
            exportConsumptions(connectedProfileId) ;
        } catch (error) {
            toast(defaultErrorToast("Problème rencontré lors de l'export des données")) ;
        }
    } ;

    return (
        <ConsumptionsBox nbAdvanced={nbAdvanced} nbQualified={nbQualified} consumptions={consumptions} onExport={onExportConsumptions} />
                
    ) ;
} ;